import React, { useState } from 'react';
import { Modal, Button, Input } from 'antd';
import { PUBLIC_EXCHANGE_WARNING } from '../../config/media';

import { CollateralModalWrapper } from './style';

const CollateralModal = ({ isVisible, exchangeData = {}, step, handleStep, onOk, handleClose }) => {
    const [isDisabled, setDisable] = useState(true);

    const handleInput = (e) => {
        if (e.target.value === "I UNDERSTAND") {
            setDisable(false)
        } else {
            setDisable(true)
        }
    }

    const renderPopup = () => {
        const projectName = exchangeData.display_name ? exchangeData.display_name : exchangeData.name;
        switch (step) {
            case 2:
                return (
                    <CollateralModalWrapper>
                        <div className="step-2-container">
                            <div className="header-txt">Going Public</div>
                            <div className='info-txt'>Check the name of your project below.</div>
                            <div className="info-align info-txt">
                                You will be able to change the name and other details after
                                going public.
                            </div>
                            <div className="inner-content title-content">
                                <div>Project name</div>
                                <Input
                                    className="Project_field"
                                    value={projectName}
                                />
                            </div>
                            <div className="btn-wrapper">
                                <Button
                                    type='primary'
                                    onClick={() => handleStep(1)}
                                >
                                    Back
                                </Button>
                                <Button
                                    type='primary'
                                    onClick={() => handleStep(3)}
                                >
                                    Confirm
                                </Button>
                            </div>
                        </div>
                    </CollateralModalWrapper>
                )
            case 3:
                return (
                    <CollateralModalWrapper>
                        <div className="step-3-container">
                            <div className="header-txt">Going Public</div>
                            <div className='info-txt'>
                                Please acknowledge that you understand that your
                                project will ramain permanently public.
                            </div>
                            <div className="inner-content info-txt">
                                <div>Type 'I UNDERSTAND' to confirm</div>
                                <Input onChange={handleInput} />
                            </div>
                            <div className="btn-wrapper">
                                <Button
                                    type='primary'
                                    onClick={() => handleStep(2)}
                                >
                                    Back
                                </Button>
                                <Button
                                    type='primary'
                                    onClick={onOk}
                                    disabled={isDisabled}
                                >
                                    I understand. Proceed.
                                </Button>
                            </div>
                        </div>
                    </CollateralModalWrapper>
                )
            case 1:
            default:
                return (
                    <CollateralModalWrapper>
                        <div className="step-1-container">
                            <div className="img-wrapper">
                                <img src={PUBLIC_EXCHANGE_WARNING} className="live-public-img" alt="live-public-img" />
                            </div>
                            <div className="header-txt">Going Public</div>
                            <div className="info-txt">
                                Going public with your crypto project is a big step and it is
                                important to know that once you've gone public there is no
                            </div>
                            <div className="info-txt">going back!</div>
                            <div className="Footer-txt">
                                Please confirm that you understand that this is permanent.
                            </div>
                            <div className="btn-wrapper">
                                <Button
                                    type='primary'
                                    onClick={handleClose}
                                >
                                    Back
                                </Button>
                                <Button
                                    type='primary'
                                    onClick={() => handleStep(2)}
                                >
                                    I understand. Proceed.
                                </Button>
                            </div>
                        </div>
                    </CollateralModalWrapper>
                )
        }
    }

    return (
        <Modal
            visible={isVisible}
            footer={false}
            width={480}
            onCancel={handleClose}
        >
            <CollateralModalWrapper>
                {renderPopup()}
            </CollateralModalWrapper>
        </Modal>
    )
}

export default CollateralModal;